// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"538":"16c0f19b","545":"32beb45f","566":"fba85ebd","603":"a10fb4a6","614":"73b6f128","676":"c4c05582"}[chunkId] + ".chunk.js";
};